import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers, IMAGES } from '../data/landing';
type Notice = {
  name: string;
  country: string;
  minutes: number;
};
export function SalesPopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timer: number;
    let lastIndex = -1;
    const show = () => {
      let index = Math.floor(Math.random() * buyers.length);
      if (index === lastIndex) index = (index + 1) % buyers.length;
      lastIndex = index;
      setNotice({
        ...buyers[index],
        minutes: 1 + Math.floor(Math.random() * 14)
      });
      timer = window.setTimeout(hide, 5000);
    };
    const hide = () => {
      setNotice(null);
      timer = window.setTimeout(show, 9000);
    };
    timer = window.setTimeout(show, 6000);
    return () => window.clearTimeout(timer);
  }, [dismissed]);
  return <div className="pointer-events-none fixed inset-x-3 top-3 z-50 flex justify-center sm:inset-x-auto sm:bottom-28 sm:left-5 sm:top-auto" data-id="element-49" data-mp="1zt60tpqxheep">
      <AnimatePresence data-id="element-50" data-mp="29psjq8zp1ve3">
        {notice && !dismissed && <motion.div key={`${notice.name}-${notice.minutes}`} role="status" initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl border border-navy/10 bg-white p-3 pr-9 shadow-xl shadow-navy/15" data-id="element-51" data-mp="29o7riq0uqoje">
            <img src={IMAGES.mainMockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-52" data-mp="2xdadub6fl5k8" />
            <div className="min-w-0" data-id="element-53" data-mp="131c84j7byrt3">
              <p className="text-sm font-extrabold text-navy" data-id="element-54" data-mp="132dguh0vj27n">
                {notice.name} from {notice.country}
              </p>
              <p className="text-sm text-muted" data-id="element-55" data-mp="v0wcdsserz0s">just purchased Calm Response 5™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-bold text-teal-dark" data-id="element-56" data-mp="q34bi99sd2kg">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-57" data-mp="14zlpz9d9uxb8" />
                {notice.minutes} min ago · Verified purchase
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:bg-cream hover:text-navy" data-id="element-58" data-mp="1dyql05pmk8in">
              <XIcon className="h-4 w-4" data-id="element-59" data-mp="1ipp6djpgzwsr" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}